import { HistoryMessageItem, MessageStatusType } from '@wui/im'

export type RoomHistoryViewportMode = 'tail' | 'anchored'

export type RoomHistoryViewport = {
  mode: RoomHistoryViewportMode
  minRank: number | null
  maxRank: number | null
  hasMoreOlder: boolean
  hasMoreNewer: boolean
  anchorEventId?: number
}

export const VIEWPORT_AROUND_BATCH_SIZE = 25
export const LAZY_LOAD_NEWER_BATCH_SIZE = 15
export const LAZY_LOAD_OLDER_BATCH_SIZE = 15

export const createDefaultRoomHistoryViewport = (): RoomHistoryViewport => ({
  mode: 'tail',
  minRank: null,
  maxRank: null,
  hasMoreOlder: false,
  hasMoreNewer: false,
})

/** Клиентский исходящий до ответа сервера: rank = Date.now()/1000, не sequential rank */
export const isPendingClientOutgoing = (message: HistoryMessageItem): boolean => {
  return message.item?.type === 'OutgoingMessageEvent'
    && (message.status === MessageStatusType.INITIAL || message.status === MessageStatusType.ERROR)
}

export const dedupeHistoryByEventId = (messages: HistoryMessageItem[]): HistoryMessageItem[] => {
  const seen = new Set<number>()
  const result: HistoryMessageItem[] = []

  messages.forEach((message) => {
    if (!message.eventId || seen.has(message.eventId)) {
      return
    }
    seen.add(message.eventId)
    result.push(message)
  })

  return result.sort((a, b) => (a.rank ?? 0) - (b.rank ?? 0))
}

export const collectRankBounds = (messages: HistoryMessageItem[]): { minRank: number | null, maxRank: number | null } => {
  let minRank: number | null = null
  let maxRank: number | null = null

  messages.forEach((message) => {
    if (message.rank === undefined) {
      return
    }
    minRank = minRank === null ? message.rank : Math.min(minRank, message.rank)
    maxRank = maxRank === null ? message.rank : Math.max(maxRank, message.rank)
  })

  return { minRank, maxRank }
}
